import { render, staticRenderFns } from "./table4.vue?vue&type=template&id=5e72e497&scoped=true&lang=pug&"
import script from "./table4.vue?vue&type=script&lang=js&"
export * from "./table4.vue?vue&type=script&lang=js&"
import style0 from "./table4.vue?vue&type=style&index=0&id=5e72e497&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72e497",
  null
  
)

export default component.exports